import styled from 'styled-components';
import Text from '@bufferapp/ui/Text';
import { grayLighter } from '@bufferapp/ui/style/colors';
import { GRID_PADDING } from '../config';

export const TitleStyled = styled(Text)`
  margin: 0;
  width: 100%;
`;

export const HeaderStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 0 ${GRID_PADDING}px;
  background-color: ${grayLighter};
  gap: 8px;
`;
